import React from "react";
import { Filter, TextInput } from "react-admin";

export const CollegeFilter = (props) => (
  <Filter {...props}>
    <TextInput
      label="Search by college name"
      source="institute_name"
      alwaysOn
    />
  </Filter>
);
